import { Updater } from "use-immer";

import {
  PendingPluginPerformanceTestType,
  RequestPluginPerformanceRequestBodyType,
  RequestPluginPerformanceResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const requestPluginPerformance = async (
  data: ApiRequest<RequestPluginPerformanceRequestBodyType>
) => {
  const resp = await api.post<RequestPluginPerformanceResponseBodyType>(
    `/v2/organizations/plugin-performance`,
    data.body
  );
  return resp.data;
};

export const useRequestPluginPerformance = (
  setPendingTests: Updater<PendingPluginPerformanceTestType[]>
) => {
  return useMutation<
    RequestPluginPerformanceResponseBodyType,
    Error,
    ApiRequest<RequestPluginPerformanceRequestBodyType>,
    any
  >({
    mutationFn: async (
      data: ApiRequest<RequestPluginPerformanceRequestBodyType>
    ) => requestPluginPerformance(data),
    onSuccess: (data) => {
      setPendingTests(data.tests);
    },
  });
};
